import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'tnFormat'
})
export class TnFormatPipe implements PipeTransform {

    transform(tn: string, args?: any): any {
        //return (tn).substr(0, 3) + '-' + (tn).substr(3, 3) + '-' + (tn).substr(6, 4);
        if (tn.length > 10)
              return '('+(tn).substr(0,tn.length-10)+') '+(tn).substr(-10,3)+'-'+(tn).substr(-7,3)+'-'+(tn).substr(-4,4);
            else
              return (tn).substr(0, 3) + '-' + (tn).substr(3, 3) + '-' + (tn).substr(6, 4);

    }
}
